// extracted by mini-css-extract-plugin
module.exports = {"main":"app_main__zAhuu","croft":"app_croft__2oCRI"};